import axios from "../libs/api.request.js";
// 面料列表
export const fabric = params => {
  return axios.request({
    url: "pc/fabric",
    method: "get",
    params: params
  });
};
// 面料列表
export const zzFabric = params => {
  return axios.request({
    url: "pc/fabric/zzFabric",
    method: "get",
    params: params
  });
};

//查询面料库存
export const getFabricStock = params => {
  return axios.request({
    url: 'pc/fabric/getFabricStock',
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/fabric.js